import { ComponentPropsWithoutRef, forwardRef, RefObject, useImperativeHandle } from 'react';
import { QueryableComponent } from '@prenuvo/halo';

import './editor.css';

export interface BaseQuillEditorRef {
  blur: () => void;
}

interface BaseQuillEditorProps
  extends QueryableComponent, Omit<ComponentPropsWithoutRef<'div'>, 'ref'> {
  blur: () => void;
  editorRef: RefObject<HTMLDivElement | null>;
}

export const BaseQuillEditor = forwardRef<BaseQuillEditorRef, BaseQuillEditorProps>(
  ({ blur, editorRef, ...props }, ref) => {
    useImperativeHandle(ref, () => ({ blur }), [blur]);

    return <div {...props} ref={editorRef} />;
  },
);

BaseQuillEditor.displayName = 'BaseQuillEditor';
